import { Icon } from '@mui/material'
import TouchRipple from '@mui/material/ButtonBase'
import { withStyles } from '@mui/styles'
import { NavLink } from 'react-router-dom'
import { checkAuth } from '../../../app/auth/authRoles'
import EgretVerticalNavExpansionPanel from './EgretVerticalNavExpansionPanel'
import { useSelector } from 'react-redux'
import { NavIcon } from './NavIcon'
import { useEffect, useState } from 'react'
import sfOauthConfig from 'app/services/sfAuth/sfAuthConfig'

const styles = theme => ({
  expandIcon: {
    transition: 'transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms',
    transform: 'rotate(90deg)'
  },
  collapseIcon: {
    transition: 'transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms',
    transform: 'rotate(0deg)'
  }
})

const EgretVerticalNav = ({ navigation }) => {
  const user = useSelector(state => state.user)
  const organization = useSelector(state => state.organization)
  const role = useSelector(state => state.user.role)
  const isInternal = sfOauthConfig.isInternal

  const renderLevels = (data, isTopLevel) => {
    return data.map((item, index) => {
      if (item.auth) {
        if (
          !checkAuth(
            item.auth,
            role,
            item,
            {
              user,
              organization
            }
          )
        ) {
          return null
        }
      }
      if (item.inGroup) {
        if (!user.groupMemberships.includes(item.inGroup)) {
          return null
        }
      }
      if (item.inOneOfGroups) {
        const isInOne = item.inOneOfGroups.some(group =>
          user.groupMemberships.includes(group)
        )
        if (!isInOne) {
          return null
        }
      }
      if (item.functionPermissions && Array.isArray(item.functionPermissions)) {
        const failedAuth = item.functionPermissions.some(func => {
          return !func({
            user,
            organization,
            isInternal
          })
        })
        if (failedAuth) {
          return null
        }
      }
      if (item.children) {
        return (
          <EgretVerticalNavExpansionPanel item={item} key={index}>
            {renderLevels(item.children, false)}
          </EgretVerticalNavExpansionPanel>
        )
      } else {
        return (
          <NavLink key={index} to={item.path} className={`nav-item ${isTopLevel? 'top-level' : ''}`}>
            <TouchRipple
              key={item.name}
              name='child'
              className='w-100'
              data-tut={item.datatut}
            >
              <NavIcon item={item}/>
              <span className='text-middle item-text nav-item-text'
                style={{paddingLeft: 10}}
              >
               {item.name}
              </span>
              {item.badge && (
                <div className={`badge bg-${item.badge.color}`}>
                  {item.badge.value}
                </div>
              )}
            </TouchRipple>
          </NavLink>
        )
      }
    })
  }

  const [zoomFactor, setZoomFactor] = useState(1);

  useEffect(() => {
    const updateZoom = () => {
      setZoomFactor(1 / window.devicePixelRatio);
    };

    window.addEventListener("resize", updateZoom);
    updateZoom(); // Initialize on mount

    return () => {
      window.removeEventListener("resize", updateZoom);
    };
  }, []);

  return (
    <div 
      className='navigation'
      style={{
        // transform: `scale(${zoomFactor})`,
        // transformOrigin: "top left",
        // display: "inline-block",
      }}    
    >
      {renderLevels(navigation, true)}
    </div>
  )
}

export default (withStyles(styles)(EgretVerticalNav))
